var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{key:_vm.id,staticClass:"UniverseCard"},[_c('img',{staticClass:"UniverseCard__illustration",attrs:{"src":_vm.picture.thumb,"alt":_vm.name}}),_c('h4',{staticClass:"UniverseCard__title"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }